// extracted by mini-css-extract-plugin
export default {"detailPage":"PostDetailsPage_detailPage__iVxXV","topBar":"PostDetailsPage_topBar__llo1O","error":"PostDetailsPage_error__HBNOB"};